<template>
  <div>
    <b-overlay :show="processing" rounded="sm" class="overlay-display">
      <template #overlay>
        <div class="text-center">
          <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
      <h2><strong>Manage Dev ECS Services </strong></h2>
      <div class="flex" style="margin-top: 1rem;">
        <b-button
          style="margin-right: 0.5rem;"
          type="submit"
          variant="danger"
          class="form-submit-button submit-button"
          @click="turnOff"
          >Turn off services</b-button
        >
        <b-button
          style="margin-left: 0.5rem;"
          type="submit"
          variant="success"
          class="form-submit-button submit-button"
          @click="turnOn"
          >Turn on services</b-button
        >
      </div>
      <div style="margin-top: 1rem;">
        <h3>Cluster Services Operational Status: (Refresh every 30 secs)</h3>
        <ol style="margin-top: 0.75rem;" class="list-group list-group-numbered">
          <li
            v-for="(cluster, index) in clusters"
            class="list-group-item"
            :key="index"
          >
            {{ "Cluster: " + cluster.cluster }}
            <ul class="mt-2 ms-4">
              <li v-for="(service, index) in cluster.services" :key="index">
                <p>
                  Service:
                  <span
                    :class="service.running ? 'text-success' : 'text-danger'"
                    >{{ service.service }}</span
                  >
                </p>
              </li>
            </ul>
          </li>
        </ol>
        <div style="margin-top: 1rem;">
          <h4>Legend:</h4>
          <ul>
            <li><span class="text-success">Service: Running</span></li>
            <li><span class="text-danger">Service: Stopped</span></li>
          </ul>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
const ENDPOINT = "https://admin.calliadev.com";
export default {
  data() {
    return {
      show: true,
      processing: false,
      clusters: [],
      intervalId: null
    };
  },
  async mounted() {
    await this.fetchClusterStatus();
    this.intervalId = setInterval(this.fetchClusterStatus, 30000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    async fetchClusterStatus() {
      const res = await this.axios.get(ENDPOINT + "/ecs/clusters/status", {
        headers: {
          Authorization: "Bearer " + this.$store.getters.idToken
        }
      });

      if (res.status === 200) {
        this.clusters = res.data;
      } else {
        this.$emit("displayAlert", {
          message: "Error: Unable to fetch ECS services.",
          isError: true
        });
      }
    },
    async turnOn(event) {
      this.processing = true;
      event.preventDefault();
      await this.axios
        .put(ENDPOINT + "/ecs/clusters/turn-on", {
          headers: {
            Authorization: "Bearer " + this.$store.getters.idToken
          }
        })
        .then(async response => {
          if (response.status === 200) {
            await this.fetchClusterStatus();
            this.$emit("displayAlert", {
              message: "Success: All ECS services have been turned on.",
              isError: false
            });
          }
        })
        .catch(error => {
          this.$emit("displayAlert", {
            message:
              "Error: Something went wrong with turning on ECS services.",
            isError: true
          });
          this.processing = false;
        });
      this.processing = false;
      this.onReset();
    },
    async turnOff(event) {
      this.processing = true;
      event.preventDefault();
      await this.axios
        .put(ENDPOINT + "/ecs/clusters/turn-off", {
          headers: {
            Authorization: "Bearer " + this.$store.getters.idToken
          }
        })
        .then(async response => {
          if (response.status === 200) {
            await this.fetchClusterStatus();
            this.$emit("displayAlert", {
              message: "Success: All ECS services have been turned off.",
              isError: false
            });
          }
        })
        .catch(error => {
          this.$emit("displayAlert", {
            message:
              "Error: Something went wrong with turning off ECS services.",
            isError: true
          });
          this.processing = false;
        });
      this.processing = false;
      this.onReset();
    },
    onReset(event) {
      if (event) {
        event.preventDefault();
      }
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>
